var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.vt=require("ttag");module.exports=$CLJS.vt;